/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SwapScreenerLeadResidentsRequest
 */
export interface SwapScreenerLeadResidentsRequest {
    /**
     * ID of the first lead
     * @type {string}
     * @memberof SwapScreenerLeadResidentsRequest
     */
    lead_id_1: string;
    /**
     * ID of the second lead
     * @type {string}
     * @memberof SwapScreenerLeadResidentsRequest
     */
    lead_id_2: string;
    /**
     * A date when the swap should take effect. Must be today or in the past, and after both leads' current move-in dates.
     * @type {Date}
     * @memberof SwapScreenerLeadResidentsRequest
     */
    swap_date: Date;
}

/**
 * Check if a given object implements the SwapScreenerLeadResidentsRequest interface.
 */
export function instanceOfSwapScreenerLeadResidentsRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "lead_id_1" in value;
    isInstance = isInstance && "lead_id_2" in value;
    isInstance = isInstance && "swap_date" in value;

    return isInstance;
}

export function SwapScreenerLeadResidentsRequestFromJSON(json: any): SwapScreenerLeadResidentsRequest {
    return SwapScreenerLeadResidentsRequestFromJSONTyped(json, false);
}

export function SwapScreenerLeadResidentsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SwapScreenerLeadResidentsRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'lead_id_1': json['lead_id_1'],
        'lead_id_2': json['lead_id_2'],
        'swap_date': (new Date(json['swap_date'])),
    };
}

export function SwapScreenerLeadResidentsRequestToJSON(value?: SwapScreenerLeadResidentsRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'lead_id_1': value.lead_id_1,
        'lead_id_2': value.lead_id_2,
        'swap_date': (value.swap_date.toISOString().substring(0,10)),
    };
}

